import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

import { RichViewLogsDrawerWrapperStyled } from "../../rich-logs-components";

export const ProductionViewLogsDrawerWrapperStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "drawer-production-view-logs-wrapper",
  },
)<{ $isRtl: boolean }>`
  ${RichViewLogsDrawerWrapperStyled}
  position: relative;
  min-height: 100%;
`;
